import { useState, useEffect, useMemo, forwardRef } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  ListSubheader,
  TextField,
  InputAdornment,
} from '@mui/material';
import { getAllBillingRoles } from 'src/services/employeeService';
import SearchIcon from '@mui/icons-material/Search';

interface AllocationRoleMultiSelectProps {
  value: string | string[] | [],
  onChange: (e: any) => void,
}

const AllocationRoleMultiSelect = forwardRef((props: AllocationRoleMultiSelectProps, _ref) => {
  const [billingRoles, setBillingRoles] = useState([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [searchText, setSearchText] = useState<string>('');
  
  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  useEffect(() => {
    const fetchBillingRoles = () => {
      getAllBillingRoles().then((res) => setBillingRoles(res.data));
    }

    fetchBillingRoles();
  }, []);


  const filteredBillingRoles = useMemo(
    () =>
      billingRoles.length > 0 &&
    billingRoles?.filter((option) => containsText(option?.name, searchText)),
    [billingRoles, searchText]
  );

  useEffect(() => {
    const selectedName = [];
    if(props?.value && props?.value.length > 0){
      for(let i=0; i < props?.value.length; i++){
        const result = billingRoles.filter(e => e.id.toString() === props?.value[i]);
        selectedName.push(result[0]?.name);
      }
    }
    setSelectedItems(selectedName);
  }, [billingRoles, props?.value]);

  return (
    <FormControl fullWidth>
      <InputLabel
        style={{
          fontSize: '12px'
        }}
      >
        Allocation Role
      </InputLabel>
      <Select
        id="filter-resource"
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        multiple
        size="small"
        value={props.value}
        renderValue={() => selectedItems.join(', ')}
        onChange={(e) => props?.onChange(e)}
        onClose={() => setSearchText('')}
      >
        <ListSubheader>
          <TextField
            id="search-stakeholderRole"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          ></TextField>
        </ListSubheader>
        {
          filteredBillingRoles?.length > 0 &&
          filteredBillingRoles.map((resource, i) => {
            return (
              <MenuItem key={resource?.id} 
                value={resource?.id}>
                  <Checkbox checked={props?.value.indexOf(resource?.id as never) > -1} />
                  <ListItemText primary={resource?.name} />
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default AllocationRoleMultiSelect;
